import { DataType } from "../../../tables"
import { normalize } from "../../../utils/typeUtils"

export const useFiltersHooks = () => {
    const search = (
        list: DataType[],
        valuesFn: (dataType: DataType) => string[],
        sortFn: (dataType_A: DataType, dataType_B: DataType) => number,
        text = '',
        showAll = false
    ): DataType[] => {
        const words = normalize(text).split(/\s+/).filter(word => word)
        const matchFn = (dataType: DataType, words: string[]) =>
            words.reduce((count, word) =>
                valuesFn(dataType).some(value => value.includes(word)) ? count + 1 : count, 0)
        
        return list
            .sort(sortFn)    
            .sort((dataTypeA, dataTypeB) => words.length > 0 ? matchFn(dataTypeB, words) - matchFn(dataTypeA, words) : 0)
            .filter(dataType => showAll || words.length === 0 || matchFn(dataType, words) > 0)
    }

    const search2 = async (
        list: DataType[],
        searchText = '',
        valuesFn: (dataType: DataType) => Promise<string[]>,
        filterFn?: (dataType: DataType) => boolean,
        sortFn?: (dataType_A: DataType, dataType_B: DataType) => number,
        sortByScore = false,
        showAll = false
    ): Promise<DataType[]> => {
        const words = normalize(searchText).split(/\s+/).filter(word => word)
        
        const matchFn = async (dataType: DataType, words: string[]) => {
            const values = await valuesFn(dataType)
            return words.length > 0 ? words.reduce((count, word) => values.some(value => value.includes(word)) ? count + 1 : count, 0) : 1
        }
        const scoresData = await Promise.all(list.map(async dataType => ({
            dataType,
            score: await matchFn(dataType, words)
        })))

        let resultList = filterFn ? list.filter(filterFn) : list

        resultList = showAll ? resultList : resultList.filter(dataType => scoresData.find(s => s.dataType === dataType)!.score > 0)

        resultList = sortFn ? resultList.sort(sortFn) : resultList
        
        resultList = sortByScore ? resultList.sort((dataType_A, dataType_B) => {
            const scoreA = scoresData.find(s => s.dataType === dataType_A)!.score
            const scoreB = scoresData.find(s => s.dataType === dataType_B)!.score
            return scoreB - scoreA
        }) : resultList

        return resultList
    }

    return {
        search,
        search2
    }
}
